import * as React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { UpdateAttendanceSettingMutationVariables } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { Return } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import EmployeeAccessSearchField from './EmployeeAccessSearchField'
import FaceRecognitionUrl from './FaceRecognitionUrl'

type FaceRecognitionProps = {
  policyForm: FormikProps<UpdateAttendanceSettingMutationVariables>
  updatePolicy: (value?: { successFlash: boolean }) => Promise<Return<void>>
  showFaceRecognitionSettings: boolean
  attendanceSetting: AttendanceSetting
}

const FaceRecognitionToggle = ({
  showFaceRecognitionSettings,
  updatePolicy,
  policyForm,
  attendanceSetting,
}: FaceRecognitionProps) => {
  const faceRecognitionField = policyForm.values.faceRecognition

  const onChange = (status: boolean) => {
    policyForm.setFieldValue('faceRecognition', status)

    if (status) {
      policyForm.setValues({
        ...policyForm.values,
        faceRecognition: status,
        idClockSharedDevice: false,
      })
    }

    updatePolicy()
  }

  return (
    <CollapsableCard
      open={showFaceRecognitionSettings}
      Card={
        <Box
          gap="s8"
          extra={{ 'data-intercom-target': 'attendance-policy-details-toggles-face-recognition' }}
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="medium">
              {i18n.t('time_tracking.settings.form.toggle.face_recognition.title')}
            </Text.Normal>
            <TogglerCheckbox
              value={!!faceRecognitionField}
              onChange={(newValue) => onChange(newValue)}
              labelBefore
            />
          </Box>
          <Text.Normal color="grey800" htmlTag="div">
            {i18n.t('time_tracking.settings.form.toggle.face_recognition.description')}
          </Text.Normal>
        </Box>
      }
      Content={
        <Box gap="s8" padding="s24">
          <EmployeeAccessSearchField policyForm={policyForm} updatePolicy={updatePolicy} />
          <FaceRecognitionUrl
            policyForm={policyForm}
            updatePolicy={updatePolicy}
            attendanceSetting={attendanceSetting}
          />
        </Box>
      }
    />
  )
}

export default observer(FaceRecognitionToggle)
